import React from 'react'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import withApp from '@brainstud/react-tbl/core/provider/withApp'
// TODO move ui
// import { Page, Layout } from '@brainstud/schiphol-vtc-ui'
// TODO get appRoutes from provider
import { appRoutes } from '@brainstud/react-tbl/features'
import { routeTo, getBySlug, getBySlugFromIdsArray, getNextItem, getPrevItem, nextNavTo } from '@brainstud/react-helpers'
import { setProgress } from '../../store/actions'
import { NavigationView } from '@brainstud/react-tbl/features/navigation'
import { ContentType, FooterType } from './types'
import { DevMode } from '../shared'

class LessonView extends React.Component {
  componentDidMount() {
    // console.log('lesson mount', this.props.match.params)
    this.props.setProgress({
      id: this.props.match.params.chapter,
      data: this.props.match.params.lesson,
    })
  }

  componentDidUpdate(props) {
    // console.log('lesson update', this.props.match.params)
    this.props.setProgress({
      id: this.props.match.params.chapter,
      data: this.props.match.params.lesson,
    })
  }

  render() {
    if(!this.props.chapter)
      return <Redirect to={routeTo(appRoutes, 'home')} />

    if(!this.props.lesson)
      return <Redirect to={routeTo(appRoutes, 'chapter', { chapter: this.props.chapter.slug })} />

    return (
      <NavigationView type="chapter" id={this.props.chapter.id}>
        <Page>
          <Layout toggleSidebar={this.props.app.toggleSidebar}>
            {this.props.app.globalMap ? (
              <ContentType type="map" {...this.props} />
            ) : (
              <ContentType type={this.props.lesson.type} {...this.props} />
            )}

            <FooterType type={this.props.lesson.type} {...this.props} />
          </Layout>

          {process.env.NODE_ENV === 'development' &&
            <DevMode chapter={this.props.chapter} lesson={this.props.lesson} />
          }
        </Page>
      </NavigationView>
    )
  }
}

export default withApp(connect(
  (state, props) => {
    const navigation = state.navigation.list.byId
    const lessons = state.chapters.lessons.byId
    const chapters = state.chapters.chapters.byId
    // const aspects = state.chapters.aspects.byId

    const chapter = getBySlug(chapters, props.match.params.chapter)
    if(!chapter) return { chapter: false }

    const lesson = getBySlugFromIdsArray(chapter.lessons, lessons, props.match.params.lesson)
    const navItem = Object.values(navigation).find(item => item.chapterId === chapter.id)
    if(!lesson) return { chapter }

    const chapterHasQuiz = chapter.quizId
    const nextLesson = getNextItem(chapter.lessons, lessons, lesson.id)
    const prevLesson = getPrevItem(chapter.lessons, lessons, lesson.id)

    const prevButtonTo = prevLesson
      ? routeTo(appRoutes, 'lesson', { chapter: chapter.slug, lesson: prevLesson.slug })
      : routeTo(appRoutes, 'chapter', { chapter: chapter.slug })

    const nextButtonTo = nextLesson
      ? routeTo(appRoutes, 'lesson', { chapter: chapter.slug, lesson: nextLesson.slug })
      : chapterHasQuiz
        ? routeTo(appRoutes, 'quiz', { chapter: chapter.slug })
        : nextNavTo(state, navItem, appRoutes)

    return { chapter, lesson, nextButtonTo, prevButtonTo }
  },
  (dispatch) => ({
    setProgress: params => dispatch(setProgress(params))
  }),
)(LessonView))
